import { defineFeature } from "../../app/feature";
import { RecipeEditorPage } from "./RecipeEditorPage";
import { RecipesPage } from "./RecipesPage";

/** Extraction recipes (task 4090.4; DESIGN-SPEC 16.2): edit a family's field definitions, preview
 * where each anchor lands on the representative files, add test cases, and approve. Owned by the
 * document-families lane. */
export default defineFeature({
  id: "recipes",
  title: "Extraction recipes",
  routes: [
    { path: "/recipes", Component: RecipesPage },
    { path: "/recipes/:versionId", Component: RecipeEditorPage },
  ],
  nav: { label: "Extraction recipes", path: "/recipes", section: "Sources", order: 30 },
  permissions: ["engagement.read", "mapping.propose", "mapping.certify"],
});
